module.exports = __webpack_public_path__ + "img/foto10.467b7af8.jpg";